"use strict";
import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import _ from "underscore";
class Table extends React.Component {
  render() {
    return /* @__PURE__ */ jsx("div", { className: "v3__table-wrapper v3__table-wrapper--default", children: /* @__PURE__ */ jsx("div", { className: "v3__table-layout-row-wrap", children: /* @__PURE__ */ jsx("div", { className: "v3__table-layout-column", children: /* @__PURE__ */ jsx("div", { className: "v3__table-inner-layout-container", children: /* @__PURE__ */ jsxs("table", { className: "v3__table v3__table--default", children: [
      /* @__PURE__ */ jsx("thead", { className: "v3__table-head v3__table-head--default", children: /* @__PURE__ */ jsx("tr", { children: _.map(this.props.columns, this.headerCell) }) }),
      /* @__PURE__ */ jsx("tbody", { className: "v3__table-body v3__table-body--default", children: _.map(this.props.rows, this.rowCells.bind(this)) })
    ] }) }) }) }) });
  }
  headerCell(column) {
    return /* @__PURE__ */ jsx("th", { className: "v3__table-cell v3__table-cell--head v3__table-cell--head--default", children: /* @__PURE__ */ jsx("div", { className: "v3__table-cell--head--text", children: column.heading }) });
  }
  rowCells(row) {
    const rowCell = (column) => /* @__PURE__ */ jsx("td", { className: "v3__table-cell v3__table-cell--body", children: column.content(row) });
    return /* @__PURE__ */ jsx("tr", { className: "v3__table-body-row v3__table-body-row--default", children: _.map(this.props.columns, rowCell) });
  }
}
export { Table };
